import React from 'react';
import { getDriverAge } from '../Utils';

const ResultStat = ({ term, results, type, onClickHandler }) => {
    const resultsCount = results.total.value;
    const title = resultsCount > 0 ? results.hits[0]._source.title : `No ${type} found`;
    const permalink = resultsCount > 0 ? results.hits[0]._source.permalink : '#';
    let imageUrl = resultsCount > 0 ? results.hits[0]._source.featuredImage : false;

    if (imageUrl === false || imageUrl.includes('images/media/default.png')) {
        imageUrl = `${theme_details.templateUrl}/images/motorsport-icon.png`;
    }

    const getSubtitle = () => {
        let subtitle;

        switch (type) {
            case 'Races':
                subtitle = results.hits[0]._source.circuit;
                break;
            case 'Drivers':
                subtitle = `Age ${getDriverAge(results.hits[0])}`;
                break;
            case 'Teams':
                if (!('dateOfFirstRace' in results.hits[0]._source)) {
                    subtitle = 'Unknown active years';
                    break;
                }

                const dofr = new Date(Date.parse(results.hits[0]._source.dateOfFirstRace.replace(/-/g, '/')));
                const dolr =
                    'latestRaceDate' in results.hits[0]._source
                        ? new Date(Date.parse(results.hits[0]._source.latestRaceDate.replace(/-/g, '/')))
                        : undefined;

                subtitle = dofr.getFullYear();

                if (dolr === undefined) {
                    const yearsRaced = results.hits[0]._source.yearsRaced || 0;
                    const untilPresentYear = dofr.getFullYear() + parseInt(yearsRaced);

                    subtitle += ` - ${untilPresentYear}`;
                } else {
                    subtitle += ` - ${dolr.getFullYear()}`;
                }

                break;
            case 'Championships':
                subtitle = results.hits[0]._source.season[0];
                break;
            case 'Circuits':
                subtitle =
                    'activeYears' in results.hits[0]._source && results.hits[0]._source.activeYears.length > 0
                        ? results.hits[0]._source.activeYears
                        : 'Unknown active years';
                break;
        }

        return subtitle;
    };

    const handleViewAll = e => {
        e.preventDefault();

        onClickHandler(type);
    };

    return (
        <div className="database-stat">
            <div className="database-stat__content">
                <h3 className="database-stat__title proxima">
                    <strong>{resultsCount}</strong> {type}
                </h3>
                <div className="database-stat__inner">
                    <a className="database-stat__link" href={permalink}>
                        {imageUrl && (
                            <div className="database-stat__image circular-image">
                                <img src={imageUrl} alt={`${type} result image for ${title}`} />
                            </div>
                        )}
                        <h4 className="database-stat__inner-title">{title}</h4>
                    </a>
                    {resultsCount > 0 && (
                        <>
                            <a className="database-stat__link" href={permalink}>
                                <h5 className="database-stat__inner-subtitle proxima">{getSubtitle()}</h5>
                            </a>
                            <a className="button button--outline" href="#" onClick={handleViewAll}>
                                View all
                            </a>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ResultStat;
